$(document).ready(function(){
 jQuery(window).scroll(function(){ 
    var y = jQuery(window).scrollTop();
	if (y > 200) {
		jQuery(".main-menu").addClass('sticky-header');
		jQuery("body").addClass('sticky-header');
	} else {
		jQuery(".main-menu").removeClass('sticky-header');
		jQuery("body").removeClass('sticky-header');
	}
});
  
  if (screen.width < 960) {
    

  setTimeout(function() {
        var showChar = 100;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Show more >";
    var lesstext = "Show less";
    

    jQuery('.stamped-reviews-message-block.stamped-style-color-text').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span></a></span>';
 
            jQuery(this).html(html);
        }
 
    });
    
    }, 2500);

  }
 
});